
export function initHeaderColor(){
    /*if ($('.m-slider_introslider').length){
        $('.a-logolink img').attr('src','/typo3conf/ext/boy_template/Resources/Public/Theme/dev/assets/img/boy_logo_n-negative.svg')
    }  */
    if ($('.o-section_orange.header').length){
        $('.a-logolink img').attr('src','/typo3conf/ext/boy_template/Resources/Public/Theme/prod/assets/img/boy_logo_n-or.svg');
    }  
    if ($('.m-headerstatic grey').length){
        $('.a-logolink img').attr('src','/typo3conf/ext/boy_template/Resources/Public/Theme/prod/assets/img/boy_logo_n_grey');
    }  
}